import script from "./StatsModeShareInitialQuery.vue?vue&type=script&lang=js"
export * from "./StatsModeShareInitialQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__